import { render, staticRenderFns } from "./AppNoticeWrite.vue?vue&type=template&id=5643ad2c&"
import script from "./AppNoticeWrite.vue?vue&type=script&lang=js&"
export * from "./AppNoticeWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports